import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { useHandleSupport } from 'utils/hooks/useHandleSupport';

const StyledButton = styled.button`
  ${({ theme: { colors, utils, tp } }) => `
    background: none;
    border: none;
    color: rgba(43, 20, 59, 0.60);
    cursor: pointer;
    padding: ${utils.rem(8)} 0;
    text-align: center;
    ${tp.p3}

    &:hover {
      text-decoration: underline;
    }
  `}
`;

const SupportButton = () => {
  const { t } = useTranslation();
  const handleSupport = useHandleSupport();

  return (
    <StyledButton
      onClick={handleSupport}
      dangerouslySetInnerHTML={{ __html: t('auth.needHelp') }}
    />
  );
};

export default SupportButton;